import React, { ReactNode } from 'react'
import { moduleContext } from 'react-contextual'

/**
 * Whatever is handed to the provider is passed straight through to consumers,
 * so this stays open. `match` is called out because it is the one prop the
 * sibling module providers (`ReportingProvider`, `ContactsProvider`, ...) are
 * all given, from the route they are rendered under.
 */
type TApiStateContextValue = {
  match?: unknown
  [prop: string]: unknown
}

type TApiStateProviderProps = TApiStateContextValue & {
  /** The context object `moduleContext()` creates and injects. */
  context: React.Context<TApiStateContextValue>
  children?: ReactNode
}

const ApiStateProvider = moduleContext()(({ context, children, ...props }: TApiStateProviderProps) => {
  const { match } = props

  const _store: TApiStateContextValue = {
    match,
    ...props,
  }
  return <context.Provider value={_store}>{children}</context.Provider>
})

export default ApiStateProvider
